import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

// STYLES
import './index.scss';
// STYLES END

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
